module.exports = __webpack_public_path__ + "static/media/E.bc9309d4.png";